import React, { useMemo, useState, useEffect, useRef } from "react"
import "./AddManageStaff.scss"
import { useHistory } from "react-router"

import { GlobalFilter } from "../../../frontDesk/patientDirectory/GlobalFilter"
import {
  updateManageStaff,
  getAllManageStaffDetailsByCenter
} from "../../../../core/services/api"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
import { COLUMNS } from "./AddManageStaffColumns"
import { useSelector } from "react-redux"
import { MocUserRole } from "../../../../core/services/models/Enums"
import EditManageStaff from "../EditManageStaff/EditManageStaff"
import Toast from "components/Toast"

function AddManageStaff() {
  const history = useHistory()
  const [data, setData] = useState([])
  const [success, setSuccess] = useState<boolean>(false)
  const columns = useMemo(() => COLUMNS, [])
  const componentRef = useRef()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const userRole = useSelector((state: any) => state?.user?.role)
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);
  useEffect(() => {
    if (userRole === MocUserRole.CENTER_ADMIN) {
      getStaffDetails()
    }
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  /**
   * @param {any} path
   */
  const redirectTo = async (path: any) => {
    const reqBody = {
      ...path,
      // centerId: [userDetail?.currentCenter?.centerId],
    }
    reqBody["centers"].push(userDetail?.currentCenter)
    delete reqBody["mocConsultantId"]
    updateManageStaff(path?.id, reqBody)
      .then((res) => {
        console.log("res", res)
        setSuccess(true)
        // setData(res)
        // history.push(`/manageStaffPatients`)
      })
      .catch((err) => {
        console.log("Err,", err)
      })
    // history.push({
    //   pathname: '/editManageStaff',
    //   state: { idValue: path },
    // })
  }

  return (
    <div className="add-manage-staff-container">
      {success ? (
        <Toast
          textMessage="Staff Added Successfully"
          onCloseText={"Close"}
          onClose={() => {
            getStaffDetails()
            setSuccess(false)
          }}
          type="success"
        ></Toast>
      ) : ""
      }
      <div className="add-manage-staff-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/manageStaff")
          }}
        >
          <img
            src={"../../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="manage-staff-text">Add Staff</div>
      </div>
      {
        userRole === MocUserRole.CENTER_ADMIN ? (
          <div className="add-manage-staff-container">
            <div className="row add-new">
              <div className="search-container">
                <div>
                  <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
                </div>
              </div>
              <div>
                <table
                  {...getTableProps()}
                  // @ts-ignore
                  ref={componentRef}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps()}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                paddingLeft: "40px",
                              }}
                            >
                              {column.render("Header")}
                            </div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>

                  <tbody
                    className="border-radiusImportant"
                    {...getTableBodyProps()}
                  >
                    {rows.map((row) => {
                      prepareRow(row)
                      return (
                        <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                          {row.cells.map((cell) => {
                            return (
                              <td
                                onClick={() => {
                                  if (cell?.column?.id?.toLowerCase() === "add") {
                                    redirectTo(row?.original)
                                  }
                                }}
                                style={{
                                  maxWidth: "300px",
                                  width: "350px",
                                  wordWrap: "break-word",
                                  maxHeight: "100px",
                                  paddingLeft: "40px",
                                  verticalAlign: "left",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                  letterSpacing: "1.35px",
                                  textAlign: "initial",
                                }}
                                {...cell.getCellProps()}
                              >
                                {cell.render("Cell")}
                              </td>
                            )
                          })}
                        </tr>
                      )
                    })}
                  </tbody>
                  <tfoot>
                    {footerGroups.map((footerGroup) => (
                      <tr {...footerGroup.getFooterGroupProps()}>
                        {footerGroup.headers.map((column) => (
                          <td {...column.getFooterProps()}>
                            {column.render("Footer")}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <EditManageStaff
            origin="Add"
          />
        )
      }
    </div>
  )

  function getStaffDetails() {
    if (userDetail?.currentCenter?.centerId) {
      getAllManageStaffDetailsByCenter(userDetail?.currentCenter?.centerId)
        .then((res) => {
          setData(res)
        })
        .catch((err) => {
          console.log("Err,", err)
        })
    }
  }
}
export default AddManageStaff
